module.exports = __webpack_public_path__ + "asset/questos--522b7a.svg";